<div id="toast-container"></div>
<app-loader [isLoading]="isLoading()" />
<router-outlet />
